import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function setArtiklidSwiper() {
    let swiperInstances = [];

    const swiperArtiklidElements =
        document.querySelectorAll(".swiper-artiklid");

    if (!swiperArtiklidElements.length) {
        return;
    }

    swiperArtiklidElements.forEach((element) => {
        const swiperWrapper = element.querySelector(".swiper-wrapper");
        const slides = swiperWrapper.querySelectorAll(".swiper-slide");
        const slidesCount = slides.length;
        let dataColumns = parseInt(swiperWrapper.getAttribute("data-columns"));
        let dataMobileCards = parseFloat(
            element.getAttribute("data-mobile-cards")
        );

        // Prevent initialization if .is-layout-grid is present and viewport is greater than 900px
        if (
            swiperWrapper.classList.contains("is-layout-grid") &&
            window.innerWidth > 1000
        ) {
            return;
        }

        if (
            swiperWrapper.parentElement.parentElement.className.includes(
                "articles-layout-vertical"
            )
            //  && window.innerWidth > 1000
        ) {
            return;
        }

        let swiper;
        if (
            element.parentElement.className.includes(
                "articles-layout-horizontal"
            ) &&
            (document.body.classList.contains("vikerkaar") ||
                document.body.classList.contains("sirp") ||
                document.body.classList.contains("looming"))
        ) {
            let spaceBetween = 40;

            // if (
            //     document.body.classList.contains("sirp") &&
            //     document.body.querySelector(".uudised-ja-pressiteated")
            // ) {
            //     spaceBetween = 0;
            // }

            swiper = new Swiper(element, {
                slidesPerView: dataMobileCards,
                spaceBetween: spaceBetween,

                modules: [Navigation, Pagination],
                pagination: {
                    el: element.querySelector(".swiper-pagination"),
                    clickable: true,
                },
                navigation: {
                    nextEl: element.querySelector(".swiper-button-next"),
                    prevEl: element.querySelector(".swiper-button-prev"),
                },
                breakpoints: {
                    1000: {
                        slidesPerView:
                            dataColumns < slidesCount
                                ? dataColumns
                                : slidesCount,
                        loop: false,
                        simulateTouch: true,
                    },
                },
                on: {
                    init() {
                        updateSlidesPerGroup(this);
                        updatePaginationBullets(this, slidesCount);
                    },
                },
            });
        } else {
            swiper = new Swiper(element, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 40,

                modules: [Navigation, Pagination],
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    1000: {
                        slidesPerView: slidesCount,
                        simulateTouch: false,
                    },
                },
            });
        }

        swiperInstances.push(swiper);
    });

    setSwiperWrapperHeight();

    return swiperInstances;
}

function setVarskedNumbridSwiper() {
    const swiperVarskedNumbridElement = document.querySelector(
        ".swiper-varsked-numbrid"
    );

    if (!swiperVarskedNumbridElement) {
        return;
    }

    const swiperSlidesCount = swiperVarskedNumbridElement.querySelectorAll(
        ".swiper-varsked-numbrid .swiper-slide"
    ).length;

    const swiperVarskedNumbrid = new Swiper(swiperVarskedNumbridElement, {
        loop: false,
        slidesPerView: 1.5,
        spaceBetween: 20,
        modules: [Navigation, Pagination],
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        breakpoints: {
            500: {
                slidesPerView: 2.5,
                spaceBetween: 15,
            },
            700: {
                slidesPerView: 3.5,
                spaceBetween: 15,
            },
            1000: {
                slidesPerView: 4.5,
                spaceBetween: 20,
                simulateTouch: false,
            },
            1300: {
                slidesPerView: 6.5,
                spaceBetween: 20,
                simulateTouch: false,
            },
        },
        on: {
            init() {
                updateSlidesPerGroup(this);
                updatePaginationBullets(this, swiperSlidesCount);
            },
        },
    });
}

function setHeroBannerSwiper() {
    const swiperHeroBannerElements = document.querySelectorAll(
        ".hero-banner-slider"
    );

    if (!swiperHeroBannerElements.length) {
        return;
    }

    swiperHeroBannerElements.forEach((element) => {
        const autoplay = element.classList.contains("has-auto-scroll")
            ? true
            : false;

        const autoScrollInterval = element.getAttribute(
            "data-auto-scroll-interval"
        );
        const autoScrollDelay = autoScrollInterval * 1000;

        const swiperHeroBanner = new Swiper(element, {
            loop: true,
            spaceBetween: 0,
            autoplay: true
                ? {
                      delay: autoScrollDelay,
                      pauseOnMouseEnter: true,
                  }
                : false,
            modules: [Navigation, Autoplay, Pagination],
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    });
}

function setBookSliderSwiper() {
    const swiperBookSliderElements = document.querySelectorAll(".book-slider");

    if (!swiperBookSliderElements.length) {
        return;
    }

    swiperBookSliderElements.forEach((element) => {
        const autoplay = element.classList.contains("has-auto-scroll");

        const autoScrollInterval = element.getAttribute(
            "data-auto-scroll-interval"
        );
        const autoScrollDelay = autoScrollInterval * 1000;

        const swiperWrapper = element.querySelector(".swiper-wrapper");
        const slides = swiperWrapper.querySelectorAll(".swiper-slide");
        const slidesCount = slides.length;

        const swiperBookSlider = new Swiper(element, {
            loop: true,
            autoplay: autoplay
                ? {
                      delay: autoScrollDelay,
                      pauseOnMouseEnter: true,
                  }
                : false,

            slidesPerView: 1.5,
            spaceBetween: 20,

            modules: [Navigation, Autoplay, Pagination],
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                1000: {
                    slidesPerView: 4, // Display exactly 4 slides when viewport width is >= 1000px
                    simulateTouch: false,
                    spaceBetween: 20, // Adjust spacing if necessary
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    });
}

function updateSlidesPerGroup(swiperInstance) {
    swiperInstance.params.slidesPerGroup = Math.floor(
        swiperInstance.params.slidesPerView
    );
    swiperInstance.update();
}

function updatePaginationBullets(swiperInstance, totalSlides) {
    const totalPages = Math.ceil(
        totalSlides / swiperInstance.params.slidesPerView
    );
    const paginationBullets = document.querySelectorAll(
        ".swiper-pagination-bullet"
    );

    paginationBullets.forEach((bullet, index) => {
        bullet.style.display = index < totalPages ? "inline-block" : "";
    });
}

function setSwiperWrapperHeight() {
    const swiperWrappers = document.querySelectorAll(".swiper-wrapper");

    swiperWrappers.forEach((wrapper) => {
        if (wrapper.classList.contains("is-vertical")) {
            return;
        }

        wrapper.style.height = "auto";
        const contentHeight = wrapper.scrollHeight;
        wrapper.style.height = `${contentHeight}px`;
    });
}

function initializeAllSwipers() {
    setVarskedNumbridSwiper();
    setHeroBannerSwiper();
    setBookSliderSwiper();
    setArtiklidSwiper();

}


export default initializeAllSwipers;
